import smoothScroll from 'smoothscroll';

export default class SmoothScrollingOnDemand {
    constructor( smoothScrolling ) {
        this.initScrollAnimationEffect( smoothScrolling );
    }

    initScrollAnimationEffect( smoothScrolling ) {
        smoothScrolling.addEventListener( 'click', ( e ) => {
            const targetHash = e.target.hash;
            const target = targetHash && document.querySelector( targetHash );

            if (target) {
                e.preventDefault();

                smoothScroll( target );
            }
        });
    }
}
